import { writable, type Writable } from 'svelte/store';
import { tweened } from 'svelte/motion';
import { sineInOut } from 'svelte/easing';
import type { Gradient } from './GradientStore';

export type Track = {
  fileName: string;
  title: string;
  artist: string;
  bpm: number;
  visualConfig: Gradient;
};

export enum STATE {
  PLAYING = 'playing',
  PAUSED = 'paused',
  UNINITIALIZED = 'uninitialized',
  BUFFERING = 'buffering',
  READY = 'ready',
  COMPLETED = 'completed'
}

export const CurrentTrack: Writable<Track> = writable();

export const PlayState: Writable<STATE> = writable(STATE.UNINITIALIZED);

export const bpm = tweened(60, {
  duration: 1500,
  easing: sineInOut
});
